import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.string.link";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getList, getDetail, remove } from "@/api/resource/attach";
import { mapGetters } from "vuex";
export default {
  data: function data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      attachBox: false,
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        dialogClickModal: false,
        column: [{
          label: "附件地址",
          prop: "link",
          rules: [{
            required: true,
            message: "请输入附件地址",
            trigger: "blur"
          }]
        }, {
          label: "附件域名",
          prop: "domain",
          search: true,
          rules: [{
            required: true,
            message: "请输入附件域名",
            trigger: "blur"
          }]
        }, {
          label: "附件名称",
          prop: "name",
          search: true,
          rules: [{
            required: true,
            message: "请输入附件名称",
            trigger: "blur"
          }]
        }, {
          label: "附件原名",
          prop: "originalName",
          search: true,
          rules: [{
            required: true,
            message: "请输入附件原名",
            trigger: "blur"
          }]
        }, {
          label: "附件拓展名",
          prop: "extension",
          rules: [{
            required: true,
            message: "请输入附件拓展名",
            trigger: "blur"
          }]
        }, {
          label: "附件大小",
          prop: "attachSize",
          slot: true,
          rules: [{
            required: true,
            message: "请输入附件大小",
            trigger: "blur"
          }]
        }]
      },
      data: [],
      attachForm: {},
      attachOption: {
        submitBtn: false,
        emptyBtn: false,
        column: [{
          label: '附件上传',
          prop: 'attachFile',
          type: 'upload',
          drag: true,
          loadText: '模板上传中，请稍等',
          span: 24,
          propsHttp: {
            res: 'data'
          },
          action: "/api/blade-resource/oss/endpoint/put-file-attach"
        }]
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["permission"])), {}, {
    permissionList: function permissionList() {
      return {
        addBtn: false,
        editBtn: false,
        viewBtn: false,
        delBtn: this.vaildData(this.permission.attach_delete, false)
      };
    },
    ids: function ids() {
      var ids = [];
      this.selectionList.forEach(function (ele) {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  }),
  methods: {
    handleUpload: function handleUpload() {
      this.attachBox = true;
    },
    uploadAfter: function uploadAfter(res, done, loading, column) {
      window.console.log(column);
      this.attachBox = false;
      this.refreshChange();
      done();
    },
    handleDownload: function handleDownload(row) {
      window.open("".concat(row.link));
    },
    rowDel: function rowDel(row) {
      var _this = this;

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(row.id);
      }).then(function () {
        _this.onLoad(_this.page);

        _this.$message({
          type: "success",
          message: "操作成功!"
        });
      });
    },
    handleDelete: function handleDelete() {
      var _this2 = this;

      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(_this2.ids);
      }).then(function () {
        _this2.onLoad(_this2.page);

        _this2.$message({
          type: "success",
          message: "操作成功!"
        });

        _this2.$refs.crud.toggleSelection();
      });
    },
    beforeOpen: function beforeOpen(done, type) {
      var _this3 = this;

      if (["edit", "view"].includes(type)) {
        getDetail(this.form.id).then(function (res) {
          _this3.form = res.data.data;
        });
      }

      done();
    },
    searchReset: function searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange: function searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange: function selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear: function selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange: function currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange: function sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange: function refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad: function onLoad(page) {
      var _this4 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.loading = true;
      getList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(function (res) {
        var data = res.data.data;
        _this4.page.total = data.total;
        _this4.data = data.records;
        _this4.loading = false;

        _this4.selectionClear();
      });
    }
  }
};